import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewBookingPageLayer from "../../components/Booking/ViewBookingPageNew";
const ViewBookingPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title2="Booking" link2="/booking" title="View Booking" />

        {/* AddUserLayer */}
        <ViewBookingPageLayer />


      </MasterLayout>
    </>
  );
};

export default ViewBookingPage;
